import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { IMAGE_CONFIG } from "@angular/common";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LoaderModule } from "./loader/loader.module";
import { HeaderComponent } from "./header/header.component";
import { MainPageComponent } from "./main-page/main-page.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FileUploadModule } from "primeng/fileupload";
import { TableModule } from "primeng/table";
import { SidebarModule } from "primeng/sidebar";
import { ToastModule } from "primeng/toast";
import { DialogModule } from "primeng/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import { CarouselModule } from "primeng/carousel";
import { OperatorNavComponent } from "./operator-nav/operator-nav.component";
import { CorporateAdminNavComponent } from "./corporate-admin-nav/corporate-admin-nav.component";
import { SiteAdminNavComponent } from "./site-admin-nav/site-admin-nav.component";
import { SiteUserNavComponent } from "./site-user-nav/site-user-nav.component";
import { MultiSiteUserNavComponent } from "./multisite-user-nav/multisite-user-nav.component";
import { UserManagementModule } from "./user-management/user-management.module";
import { GlobalUploadStatusModule } from "./components/global-upload-status/global-upload-status.module";
import { RouteGuard } from "./route.guard";
import { RouteChildGuard } from "./route-child.guard";
import { NgxEchartsModule } from "ngx-echarts";
import { ColorPickerModule } from "ngx-color-picker";
import { LabHeaderComponent } from "./lab-header/lab-header.component";
import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { CalendarModule } from "primeng/calendar";
import { UserManagementNavComponent } from "./userManagementSites/user-management-nav/user-management-nav.component";

import { ErrorPageComponent } from "./components/error-page/error-page.component";
import { ExecutiveNavComponent } from "./executive-nav/executive-nav.component";
import { PeriodicReportComponent } from "./periodic-report/periodic-report.component";
import { NgSelectModule } from "@ng-select/ng-select";
import {
  SocialLoginModule,
  SocialAuthServiceConfig,
  GoogleInitOptions,
} from "@abacritt/angularx-social-login";
import { GoogleLoginProvider } from "@abacritt/angularx-social-login";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { IconMenuComponent } from "./icon-menu/icon-menu.component";
import { KnowhowComponent } from "./alerts/alert-knowhow/knowhow.component";
import { CommonModule } from "@angular/common";
import { UserManagementSitesComponent } from "./userManagementSites/user-management-sites.component";
import { DashboardSwitcherComponent } from "./userManagementSites/dashboard-switcher/dashboard-switcher.component";
import { FilterSitesPipe } from "./userManagementSites/filter-sites.pipe";
import { SiteSettingComponent } from "./site-setting/site-setting.component";
import { EquipmentAlertsSetupComponent } from "./site-setting/equipment-alerts-setup/equipment-alerts-setup.component";
import { MatStepperModule } from "@angular/material/stepper";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { AvatarModule } from "primeng/avatar";
// NgxSliderModule removed since we're using custom HTML range inputs
import { MatCheckboxModule } from "@angular/material/checkbox";
import { DividerModule } from "primeng/divider";
import { ModuleConfigDialogComponent } from "./components/module-config-dialog/module-config-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { CreateGroupDialogComponent } from "./site-setting/create-group-dialog/create-group-dialog.component";
import { DeleteConfirmationDialogComponent } from "./site-setting/delete-confirmation-dialog/delete-confirmation-dialog.component";
import { CategorySuccessDialogComponent } from "./site-setting/category-success-dialog/category-success-dialog.component";
import { SiteSavingDialogComponent } from "./site-setting/site-saving-dialog/site-saving-dialog.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { TooltipModule } from "primeng/tooltip";
import { DropdownModule } from "primeng/dropdown";
import { DownloadpdfComponent } from "./downloadpdf/downloadpdf.component";
import { AiTopicSettingsModule } from "./ai-topic-settings/ai-topic-settings.module";
import { providePrimeNG } from "primeng/config";
import { CustomTheme } from "../../src/theme/custom-theme";
import { AlertsModule } from "./alerts/alerts.module";
import { httpInterceptor } from "./report-system/core/inerceptor/http.interceptor";
import { NotificationsModule } from "./notifications/notifications.module";
import { SiteMixedDashboardService } from "./site-mixed-dashboard/site-mixed-dashboard.service";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { errorInterceptor } from "./report-system/core/inerceptor/error.interceptor";
import { RoleAccessHostComponent } from "./plant-guardian-ai-host/plant-guardian-ai-host.component";
import { HasNewAuthPermissionDirective } from "./report-system/core/directives/has-new-auth-permission.directive";
import { CookieConsentComponent } from "./compliance/cookie-consent/cookie-consent.component";
import { AiFeedbackDialogComponent } from "./components/ai-feedback-dialog/ai-feedback-dialog.component";
import { SharedNavbarComponent } from "./shared-navbar/shared-navbar.component";
import { SharedUserNavComponent } from "./shared-user-nav/shared-user-nav.component";
import { AllRoleNavComponent } from "./all-role-nav/all-role-nav.component";


const googleLoginOptions: GoogleInitOptions = {
  scopes: "profile email",
  // plugin_name:'login' //you can use any name here
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    MainPageComponent,
    OperatorNavComponent,
    CorporateAdminNavComponent,
    SiteAdminNavComponent,
    SiteUserNavComponent,
    MultiSiteUserNavComponent,
    LabHeaderComponent,
    ChangePasswordComponent,
    ErrorPageComponent,
    ExecutiveNavComponent,
    PeriodicReportComponent,
    KnowhowComponent,
    UserManagementSitesComponent,
    UserManagementNavComponent,
    DashboardSwitcherComponent,
    FilterSitesPipe,
    SiteSettingComponent,
    CreateGroupDialogComponent,
    DeleteConfirmationDialogComponent,
    CategorySuccessDialogComponent,
    SiteSavingDialogComponent,
    EquipmentAlertsSetupComponent,
    DownloadpdfComponent,
    RoleAccessHostComponent,
    SharedNavbarComponent,
    SharedUserNavComponent,
    AllRoleNavComponent,
  ],
  exports: [HeaderComponent, MainPageComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FileUploadModule,
    TableModule,
    NgbModule,
    ToastModule,
    CarouselModule,
    UserManagementModule,
    GlobalUploadStatusModule,
    DialogModule,
    SidebarModule,
    ColorPickerModule,
    SocialLoginModule,
    CalendarModule,
    LoaderModule,
    NgSelectModule,
    MatMenuModule,
    MatButtonModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatProgressBarModule,
    BreadcrumbModule,
    ButtonModule,
    InputTextModule,
    AvatarModule,
    // NgxSliderModule removed since we're using custom HTML range inputs
    MatCheckboxModule,
    DividerModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    TooltipModule,
    DropdownModule,
    AiTopicSettingsModule,
    AlertsModule,
    NotificationsModule,
    ModuleConfigDialogComponent,
    HasNewAuthPermissionDirective,
    CookieConsentComponent,
    AiFeedbackDialogComponent,
    NgxEchartsModule.forRoot({
      echarts: () => import("echarts"),
    }),
  ],
  providers: [
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
      },
    },
    MessageService,
    ConfirmationService,
    RouteGuard,
    RouteChildGuard,
    SiteMixedDashboardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: false,
        G_ENABLED_IDPS: true,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            // provider: new GoogleLoginProvider('690988255366-u0d935begk83mbm02qp8vvp26tbg568j.apps.googleusercontent.com',
            provider: new GoogleLoginProvider(
              "690988255366-epi4918ft2506v559p4rch6dfmj3o2a9.apps.googleusercontent.com",
              googleLoginOptions
            ),
          },
        ],
        onError: (err) => {
          //err
        },
      } as SocialAuthServiceConfig,
    },
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([httpInterceptor, errorInterceptor])),
    providePrimeNG({
      theme: {
        preset: CustomTheme,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-theme',
          cssLayer: false
        }
      },
      ripple: true
    }),
  ],
})
export class AppModule {}
